import GreedyNav from "../components/GreedyNav";

/* -------------------------------------------------------------------------- */
/*                                 Greedy Nav                                 */
/* -------------------------------------------------------------------------- */

const categories = window.WP_POST_CATEGORIES;
const greedyNavEl = document.querySelector(".gnav");

// if(greedyNavEl) {
const gnav = new GreedyNav({
  navElement: greedyNavEl,
  items: categories,
  itemGap: 22,
});
// }
